import NotificationsSerializer from './base';

export default class Result extends NotificationsSerializer {}
